import { useMutation } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";

export default function useAuthentication() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData, parseErrorResponseData } = useApiResponseParser();

    function useLogin() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.post(`/v1/auth/login`, parameters).then(parseSuccessResponseData),
        });
    }

    function useCognitoLogin() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.get(`/v1/auth/external/cognito`, parameters).then(parseSuccessResponseData),
        });
    }

    function useCodeExchange() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.post(`/v1/auth/callback`, parameters).then(parseSuccessResponseData),
        });
    }

    function useLogout() {
        return useMutation({
            mutationFn: (parameters: any) =>
                axiosPrivate.post(`/v1/auth/callback/logout`, parameters).then(parseSuccessResponseData),
        });
    }

    function useTokenExchange() {
        return useMutation({
            mutationFn: () => axiosPrivate.post(`/v1/auth/token`, {}).then(parseSuccessResponseData),
        });
    }

    return { useLogin, useCodeExchange, useCognitoLogin, useTokenExchange, useLogout };
}
